export default function modalPropertiesGeneric(payload: { toggledModalMethod: string }): {
  toggledModalMethod: string;
} {
  const { toggledModalMethod } = payload;
  return {
    toggledModalMethod,
  };
}
